<template>
    <nav-item v-for="menuitem in menudos" :key="menuitem.nombre" :ruta="menuitem.ruta"
        :clasesNavItem="menuitem.clasesNavItem" :nombre="menuitem.nombre" :clasesIcono="menuitem.clasesIcono" :separador="menuitem.separador">
            <span v-if="menuitem.nombre !== 'Soporte'">{{ menuitem.nombre }}</span>
            <span @click.prevent="cambiarurl()" v-if="menuitem.nombre === 'Soporte'" style="cursor:pointer;">
                {{ menuitem.nombre }}
            </span>
            <i v-if="menuitem.submenu" @click.prevent="toggleSubmenu(menuitem)"
                :class="['right fas', menuitem.submenuvisible ? 'fa-angle-down' : 'fa-angle-left']"></i>
            <div v-if="menuitem.submenu" :class="['submenu', 'collapse', { 'show': menuitem.submenuvisible }]">
                <nav-item v-for="submenuitem in menuitem.submenu" :key="submenuitem.nombre" :ruta="submenuitem.ruta"
                    :style="submenuitem.style" :clasesIcono="submenuitem.clasesIcono">
                    <span>{{ submenuitem.nombre }}</span>
                </nav-item>
            </div>
        </nav-item>
        <!-- <form id="TheFormsoporte" method="get" :action="'https://' + direccionglobal" target="TheWindow"></form> -->
</template>
<script>
import { PwgsApi } from '../services/PwgsApi';

export default {
    data() {
        return {
            sistema_facturacion: localStorage.getItem('sistema_facturacion'),
            direccionglobal: localStorage.getItem('direccion'),
            menudos: [
                {
                    nombre: 'Escritorio / Servicios',
                    ruta: '/escritorio',
                    clasesIcono: 'fas fa-home',
                    separador: false,
                },
                {
                    nombre: 'Configuración',
                    ruta: '/configuracion',
                    clasesIcono: 'fas fa-cogs',
                    separador: false,
                },
                {
                    nombre: 'Soporte',
                    ruta: '/escritorio',
                    clasesIcono: 'fas fa-question',
                    separador: false,
                },
                {
                    nombre: 'Planning',
                    ruta: '/planning',
                    clasesIcono: 'fas fa-calendar-alt',
                    separador: true,
                },
            ]
        }
    },
    methods: {        
        toggleSubmenu(menuitem) {
            menuitem.submenuvisible = !menuitem.submenuvisible;
        },
        cambiarurl() {
            //console.log('entracmabiar');
            window.open('https://' + this.direccionglobal + '/modulos/soporte/soporte.php');
            // const form = document.getElementById('TheFormsoporte');
            // if (form) form.submit();
            
            // setTimeout(() => {
            //     aux.location.href = 'https://' + this.direccionglobal + '/modulos/soporte/soporte.php';
            // }, 1000);
        },
   async comprobar() {
    const api = new PwgsApi();
    let auxusuario = localStorage.getItem('usuario');
    const resppermisos = await api.get('usuarios/' + auxusuario + '/permisos');
    var permisos = resppermisos.datos;

    console.log("permisos", permisos);

    const factencontrado = permisos.find(p => p.nombre_permiso == "Facturación");
    const adminencontrado = permisos.find(p => p.nombre_permiso == "Administración");
    const superadminencontrado = permisos.find(p => p.nombre_permiso == "Super Administración");
    const soporteencontrado = permisos.find(p => p.nombre_permiso == "soporte");

    localStorage.setItem('soporte', soporteencontrado ? 1 : 0);

    this.menudos.push({
        nombre: 'Planning Geográfico',
        ruta: '/planningGeografico',
        clasesIcono: 'fas fa-map-marked-alt',
        separador: false,
    });
    let itemsSubmenu = [];
    if (factencontrado || adminencontrado || superadminencontrado) {
        this.menudos.push({
            ruta: '/Control',
            nombre: 'Control',
            clasesIcono: 'fas fa-tachometer-alt',
            separador: true,
            submenuvisible: false,
            soloDesplegable: true,
            submenu: soporteencontrado ? [
                { nombre: 'Seg. Tramitadores', ruta: '/seguimientoTramitadores', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Seg. Operarios', ruta: '/seguimientoOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Seg. alarmas Usuarios', ruta: '/seguimientoAlarmasUsuarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Seg. alarmas Operarios', ruta: '/seguimientoAlarmasOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Seg. Sms', ruta: '/seguimientoSms', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Guardias Operarios', ruta: '/guardiasOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Vacaciones', ruta: '/vacaciones', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Ocupación Operarios', ruta: '/periodosOcupadosOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
                { nombre: 'Bloqueos', ruta: '/bloqueos', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            ] : []
        });
        itemsSubmenu = [
            { nombre: 'Facturas y registros', ruta: '/facturacion', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            /*{ nombre: 'Fichajes Usuarios', ruta: '/informeFichajes', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' }, en desarrollo*/
            { nombre: 'Albaranes', ruta: '/facturacionAlbaranes', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Satisfacción', ruta: '/informeSatisfaccion', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Autocitas', ruta: '/informesAutovisitas', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Agendas', ruta: '/informeAgendas', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Baremos', ruta: '/informeBaremos', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Calidad Operarios', ruta: '/informeCalidadOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Gremios por Expediente', ruta: '/informeGremiosExpediente', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Rentabilidad Global', ruta: '/informeRentabilidadGlobal', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Rentabilidad Global Facturación', ruta: '/informeRentabilidadGlobalFacturacion', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Tipos de Daños', ruta: '/informeTipoDanyos', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Tramitación', ruta: '/informeTramitacion', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Rentabilidad Operarios', ruta: '/informeRentabilidadOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Rentabilidad Operarios/Compañias', ruta: '/informeRentabilidadOperariosCompanyias', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Rentabilidad Trabajos Operarios/Compañias', ruta: '/informeRentabilidadTrabajosOperariosCompanyias', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Trabajos no liquidados', ruta: '/informeTrabajosNoLiquidados', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Trabajos subsanados', ruta: '/informeTrabajosSubsanadosCompanyia', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' },
            { nombre: 'Importación de autofacturas de compañía', ruta: '/importacionAutofacturasCompania', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' }






        ];
        if (this.sistema_facturacion == 'verifactu') {
            itemsSubmenu.splice(1, 0, { nombre: 'Informe Verifactu', ruta: '/informeVerifactu', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' });
        }
        if (this.sistema_facturacion !== 'no_factura') {
            itemsSubmenu.splice(3, 0, { nombre: 'Autofacturación Operarios', ruta: '/facturacionOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' });
        }
        if (this.sistema_facturacion == 'verifactu' || this.sistema_facturacion == 'no_factura') {
            itemsSubmenu.splice(3, 0, { nombre: 'Liquidación operarios', ruta: '/liquidacionOperarios', style: 'padding-left:0', clasesIcono: 'far fa-circle fa-xs' });
        }
    }
    this.menudos.push({
        nombre: 'Informes',
        ruta: '/Informes',
        clasesIcono: 'fas fa-chart-line',
        separador: false,
        submenuvisible: false,
        submenu: itemsSubmenu
    });
},
        async comprobarRGA(){
            const api = new PwgsApi();
            const resp = await api.get('parametros-pwgs/rga');
            if(resp.rga == 1){
                this.menudos.push({
                    nombre: 'RGA',
                    ruta: '/RGA',
                    clasesIcono: 'fas fa-external-link-alt',
                    separador: true,
                });
            }
        },
    },
    async mounted() {
        await this.comprobar();
        await this.comprobarRGA();
    },
    computed: {
    haySubmenuAbierto() {
        return this.menudos.some(m => m.submenu && m.submenuvisible);
    }
},
watch: {
    haySubmenuAbierto(abierto) {
        document.body.classList.toggle('sidebar-ancho', abierto);
    }
},
unmounted() {
    document.body.classList.remove('sidebar-ancho');
},
}
</script>
<style>
/* Ancho normal 250px -> 330px mientras haya un submenú desplegado */
body.sidebar-ancho .main-sidebar,
body.sidebar-ancho .main-sidebar::before {
    width: 330px;
    transition: width .3s ease-in-out;
}

body.sidebar-ancho .content-wrapper,
body.sidebar-ancho .main-header,
body.sidebar-ancho .main-footer {
    margin-left: 330px;
    transition: margin-left .3s ease-in-out;
}

/* Que el texto del submenú no se recorte */
body.sidebar-ancho .main-sidebar .submenu .nav-link p {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    line-height: 1.2;
}

/* El sidebar colapsado manda: no ensanchar en ese estado */
body.sidebar-collapse.sidebar-ancho .main-sidebar,
body.sidebar-collapse.sidebar-ancho .main-sidebar::before {
    width: 4.6rem;
}
body.sidebar-collapse.sidebar-ancho .content-wrapper,
body.sidebar-collapse.sidebar-ancho .main-header,
body.sidebar-collapse.sidebar-ancho .main-footer {
    margin-left: 4.6rem;
}
</style>